import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import {
  cloudChiprApi,
  ResourceType,
  PatchUsersMeAccountsByAccountIdResourcesApiArg,
} from "../../../services/cloudchipr.api";
import { RootState } from "../../store";
import { protectProcessResourcesSelector } from "../selectors/protectProcessResourcesSelector";
import { currentAccountIdSelector } from "../../account/selectors/current-account/currentAccountIdSelector";
import { getProtectResourceCacheKey } from "../utils/helpers";

interface ProtectThunkArgs {
  resourceType: ResourceType;
  actionType: "protect" | "unprotect";
  resources?: string[];
}

export const protectThunk = createAsyncThunk(
  "protectResource",
  async (
    { resourceType, actionType, resources }: ProtectThunkArgs,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;
    const accountId = currentAccountIdSelector(state);

    if (!accountId || !resources?.length) {
      return;
    }

    const filteredResources = protectProcessResourcesSelector(
      state,
      resourceType,
      resources,
      actionType,
    );

    const { patchUsersMeAccountsByAccountIdResources } =
      cloudChiprApi.endpoints;

    if (filteredResources.length) {
      const request: PatchUsersMeAccountsByAccountIdResourcesApiArg = {
        accountId,
        body: filteredResources,
      };
      const resourceIds = request.body.reduce((result, item) => {
        if (item.id) {
          result.push(item.id);
        }
        return result;
      }, [] as string[]);

      try {
        await dispatch(
          patchUsersMeAccountsByAccountIdResources.initiate(request, {
            fixedCacheKey: getProtectResourceCacheKey(accountId, resourceIds),
          }),
        ).unwrap();

        enqueueSnackbar(
          `Protection ${actionType === "protect" ? "enabled" : "disabled"}`,
          {
            variant: "snackbarAlert",
            AlertSnackBarProps: { severity: "success" },
          },
        );
      } catch (e) {
        // @ts-expect-error TODO: return to this after adding error type
        const errMessage = e?.data?.message || "Something went wrong";
        enqueueSnackbar(errMessage, {
          variant: "snackbarAlert",
          AlertSnackBarProps: {
            severity: "error",
          },
        });
      }
    }
  },
);
